import React from 'react';
import omit from 'lodash/omit';
import { Icon } from '../Icon';
import constants from 'Constants';
import './styles.scss';


const FaIcon = (props) => {
  const { set, ...otherProps } = props;
  return (
    <Icon {...otherProps} set={constants.ICON_SET_FONTAWESOME} />
  );
}


FaIcon.propTypes = omit(Icon.propTypes, 'set');
FaIcon.defaultProps = omit(Icon.defaultProps, 'set');
export { FaIcon };
